export interface Opcoes {
  operadoras: string[];
  bandeiras: string[];
  modalidades: string[];
}

export interface OpcoesResposta {
  operadoras?: string[] | null;
  bandeiras?: string[] | null;
  modalidades?: string[] | null;
}

export const OPCOES_VAZIAS: Opcoes = { operadoras: [], bandeiras: [], modalidades: [] };

const normalizar = (valores?: string[] | null): string[] => {
  const limpos: string[] = [];
  (valores || []).forEach((valor) => {
    const texto = (valor || "").trim();
    if (texto && limpos.indexOf(texto) < 0) {
      limpos.push(texto);
    }
  });
  return limpos.sort();
};

export const opcoesDaResposta = (resposta?: OpcoesResposta | null): Opcoes | null => {
  if (!resposta) {
    return null;
  }
  return {
    operadoras: normalizar(resposta.operadoras),
    bandeiras: normalizar(resposta.bandeiras),
    modalidades: normalizar(resposta.modalidades),
  };
};

// O servidor calcula as opcoes pelo filtro primario, que nao conhece a escolha
// ainda nao enviada; sem isso o seletor exibiria em branco o valor em uso.
export const comSelecionados = (
  opcoes: Opcoes,
  selecionados: { operadora: string; bandeira: string; modalidade: string }
): Opcoes => ({
  operadoras: normalizar(opcoes.operadoras.concat(selecionados.operadora)),
  bandeiras: normalizar(opcoes.bandeiras.concat(selecionados.bandeira)),
  modalidades: normalizar(opcoes.modalidades.concat(selecionados.modalidade)),
});
